(function () {
    "use strict";

    angular.module("app", [
        "app.sales",
        "app.cart",
        "app.product",
        "app.productDetail",
        "app.general",
        "app.customer",
        "app.account",
        "app.consulting",
        "app.core",
        "app.search",
        "app.location"
    ]);
})();
